import React from 'react';

import styled from 'styled-components';



const CTA = ({ block }) => {

  const { buttonText, buttonColor, textColor, buttonLink, newTab } = block;

  return (
    <Container>
      <CtaLink
        style={{
          color: textColor,
          backgroundColor: buttonColor
        }}
        href={buttonLink}
        target={newTab ? '_blank' : ''}
      >
        {buttonText}
      </CtaLink>
    </Container>
  )
};


export default CTA;

const Container = styled.section`
  width: 100%;
  margin: 2em 0;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

const CtaLink = styled.a`
  font-family: 'Bebas Neue', serif;
  font-size: 2.4em;
  align-self: center;
  padding: 0.4em 1em;
  margin: 1em 0;
  line-height: 1;
`;
